import { useContext, useEffect, useState } from "react";
import PersonalAccount from "../../store/PersonalAccount";
import { useTranslation } from "react-i18next";
import buildInviteLink from "../../utils/buildInviteLink";
import { copyText2, copyText3 } from "../../utils/constants";
import useMutateCopyData from "../../hooks/useMutateCopyData";
import useCurrentGame from "../../hooks/useCurrentGame";
import Game from "../../store/Game";
import ROUTES from "../../utils/routes";
import { useNavigate } from "react-router-dom";
import { SOCKET_EVENTS, SocketContext } from "../../components/SocketProvider";
import { isPWA } from "../../utils/helpers";
import usePwaPopup from "../../hooks/usePwaPopup";

export default function useController() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { setGame } = useCurrentGame();
  const [link, setLink] = useState(null);
  const [currentGame, setCurrentGame] = useState(null);
  const { socket } = useContext(SocketContext);
  const game = Game.game;
  const { openPwaModal } = usePwaPopup();

  const onJoinGame = (response) => {
    if (response.gameId === Game.game.id && response.isJoin) {
      setGame(game);
      navigate(ROUTES.END_GAME_PAGE);
    }
  };

  useEffect(() => {
    socket.current.on(SOCKET_EVENTS.JOIN_GAME_DATA, onJoinGame);
    return () => {
      socket.current.off(SOCKET_EVENTS.JOIN_GAME_DATA, onJoinGame);
    };
  }, [socket]);

  useEffect(() => {
    setGame(game);
    if (game && game.link) {
      setLink(buildInviteLink(game.link.link));
      setCurrentGame(game);
    }
    PersonalAccount.getPersonalAccountData().then(() => {
      Promise.all([Game.getAllGamesMatches()]);
    });
    if (game.invitedUserId) {
      navigate(ROUTES.END_GAME_PAGE);
    }
  }, [game]);

  const onMutateCopyData = (e) => {
    e.clipboardData.setData(
      "text/plain",
      `${t(
        currentGame && currentGame.type === "DEMO" ? copyText3 : copyText2
      )}\n${link}`
    );
    e.preventDefault();
  };

  useMutateCopyData(
    link,
    currentGame && currentGame.type === "DEMO" ? copyText3 : copyText2
  );

  const onLinkCopyHandle = () => {
    if (!isPWA()) {
      openPwaModal(game.id, true);
    }
    document.addEventListener("copy", onMutateCopyData);
    if (PersonalAccount.timerLinksMap.length) {
      const prevTimer = PersonalAccount.timerLinksMap.shift();
      clearInterval(prevTimer);
    }
    PersonalAccount.addTimer(
      setInterval(async () => {
        await PersonalAccount.getPersonalAccountData();
      }, 2000)
    );
  };

  return {
    onLinkCopyHandle,
    link,
  };
}
